import { Component, HostBinding, Input, Type } from '@angular/core';
import { ItemsListHeader } from '../items-list-header';
import { ListData } from '../list-data.service';
import {
    ItemsListHeadItemLabelComponent,
    ItemsListHeadItemLabelComponent_headComponent,
} from './head-item-label/head-item-label.component';

@Component({
    selector: 'fi-items-list-head-item',
    templateUrl: './head-item.component.html',
    styleUrls: ['./head-item.component.scss'],
    providers: [
        {
            provide: ItemsListHeadItemLabelComponent_headComponent,
            useFactory: (instance) => instance,
            deps: [ItemsListHeadItemComponent],
        },
    ],
    standalone: false,
})
export class ItemsListHeadItemComponent {
    @Input() head: ItemsListHeader;
    @Input() settings: ListData<any>;

    getComponentType(): Type<ItemsListHeadItemLabelComponent> {
        return this.head.Properties.ExtraProperties && this.head.Properties.ExtraProperties.headLabelType
            ? this.head.Properties.ExtraProperties.headLabelType
            : ItemsListHeadItemLabelComponent;
    }

    @HostBinding('class.right-aligned')
    get isRightAligned() {
        return (
            this.head.Properties &&
            this.head.Properties.ExtraProperties &&
            this.head.Properties.ExtraProperties.isRightAligned
        );
    }

    @HostBinding('class.padding-right-small')
    get smallRightPadding() {
        return (
            this.head.Properties &&
            this.head.Properties.ExtraProperties &&
            this.head.Properties.ExtraProperties.smallRightPadding
        );
    }

    isSortable() {
        return this.head.Properties.IsSortable;
    }

    Sort() {
        if (!this.isSortable()) return false;

        // we should sort by A-Z when click on other column
        // https://chainformation.atlassian.net/browse/FI-5352
        this.settings.Sort.Reverse =
            this.head.PropertyName != this.settings.Sort.Column ? false : !this.settings.Sort.Reverse;

        this.settings.Sort.Column = this.head.PropertyName;

        this.settings.raiseSortChanged();
    }

    IsShowSorter() {
        return this.head.Properties.IsSortable && this.settings.Sort.Column == this.head.PropertyName;
    }

    isWithIcon() {
        return this.head.Properties.ExtraProperties && this.head.Properties.ExtraProperties.ImgSrc;
    }

    isSortedDesk() {
        return this.settings.Sort.Column == this.head.PropertyName && this.settings.Sort.Reverse;
    }
}
